import { render } from "./Header.vue?vue&type=template&id=27b7dd1a&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=27b7dd1a&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b7dd1a"]])

export default __exports__